import { API_URLS } from "../../../../Configs/apiUrls";
import axiosInstance from "../../../../Configs/axios";

export const upVoteFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.upVoteFaq, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
